import { render, staticRenderFns } from "./AddCommissionContent.vue?vue&type=template&id=b4b90cd4"
import script from "./AddCommissionContent.vue?vue&type=script&lang=js"
export * from "./AddCommissionContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports